export default __webpack_public_path__ + "static/media/pig-green.39f97484.svg";